import { createFileRoute } from "@tanstack/react-router";
import { PublicKsefPage } from "@/features/ksef-public/public-ksef-page";

const defaultTenant = import.meta.env.VITE_PUBLIC_KSEF_TENANT ?? "prima";

export const Route = createFileRoute("/publiczne/ksef")({
	validateSearch: (search: Record<string, unknown>) => ({
		tenant:
			typeof search.tenant === "string" && search.tenant.length > 0 ? search.tenant : defaultTenant,
	}),
	component: RouteComponent,
});

function RouteComponent() {
	const { tenant } = Route.useSearch();
	return <PublicKsefPage tenant={tenant} />;
}
